import { render } from "./Discussion.vue?vue&type=template&id=c0145e22"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__